import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import {
    phases,
    licenses,
    iconUses,
    formats,
    steps,
    phasesDisplay,
    constToCSS
} from "../reducers/download";

import DownloadFlowLicenseSwitch from "./download-flow/download-flow-license-switch";
import DownloadFlowErrors from "./download-flow/download-flow-errors";
import IconPaymentForm from "./download-flow/phase-icon-payment";
import InitialPhase from "./download-flow/phase-initial";
import SelectLicense from "./download-flow/phase-select-license";
import AttributionSelect from "./download-flow/phase-attribution";
import DownloadReady from "./download-flow/phase-download-ready";
import UpsellPhase from "./download-flow/phase-upsell";
import IconTitle from "./download-flow/icon-title";
import IconCreator from "./download-flow/icon-creator";

class IconDownloadFlow extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.icon) {
            if (
                !this.props.download.pendingDownload ||
                this.props.download.pendingDownload.id != this.props.icon.id
            ) {
                this.props.downloadSetFlowActive(this.props.icon);
            }
        }
    }
    componentWillUnmount() {
        this.props.downloadResetFlow();
        if (this.props.showInModal) {
            this.props.dismissModal();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.icon) {
            if (
                !nextProps.download.pendingDownload ||
                nextProps.download.pendingDownload.id != nextProps.icon.id
            ) {
                this.props.downloadSetFlowActive(nextProps.icon);
            }
        }

        if (
            this.props.download.waitingForAuth &&
            !nextProps.download.waitingForAuth
        ) {
            if (this.props.refetchIcon) {
                this.props.refetchIcon();
            }
        }

        if (
            !this.shouldShowInModal(this.props) &&
            this.shouldShowInModal(nextProps)
        ) {
            this.props.showModal(null, "DOWNLOAD_FLOW", nextProps);
        }
    }

    shouldShowInModal(props) {
        let { download } = props;

        let { status } = download;

        if (!props.showInModal) {
            return false;
        }

        if (download.isPremiumUser) {
            return false;
        }

        return (
            status &&
            status != phases.INITIAL &&
            status != phases.DOWNLOAD_READY
        );
    }

    render() {
        let { download } = this.props;
        let { status, license } = download;
        let { pendingDownload } = this.props.download;

        if (!this.props.icon && status != phases.INITIAL) {
            return null;
        }

        if (this.shouldShowInModal(this.props)) {
            return null;
        }

        let Phase = Flow[status];

        if (!Phase) {
            return <span>??{status}??</span>;
        }

        let phaseClass = status && `phase-${constToCSS(status)}`;
        let hasCollection =
            pendingDownload &&
            pendingDownload.collections &&
            pendingDownload.collections.length;
        let classes = classnames(
            "download-flow",
            phaseClass,
            license && pendingDownload && `with-license-${constToCSS(license)}`,
            {
                "with-collection": hasCollection,
                "no-collection": !hasCollection
            }
        );

        let licenseSwitch;
        if (status != phases.UPSELL) {
            licenseSwitch = (
                <DownloadFlowLicenseSwitch
                    download={this.props.download}
                    onLicenseClick={this.props.downloadJumpToLicense}
                />
            );
        }

        let errorDisplay;
        if (!Phase.handlesOwnErrors) {
            errorDisplay = (
                <DownloadFlowErrors error={this.props.download.error} />
            );
        }

        return (
            <section className={classes}>
                <IconTitle {...this.props} />
                <IconCreator {...this.props} />
                <div className="phase-container">
                    {licenseSwitch}
                    <Phase {...this.props} />
                    {errorDisplay}
                </div>
            </section>
        );
    }
}

const Flow = {
    [phases.INITIAL]: InitialPhase,
    [phases.SELECT_LICENSE]: SelectLicense,
    [phases.ATTRIBUTION]: AttributionSelect,
    [phases.DOWNLOAD_READY]: DownloadReady,
    [phases.UPSELL]: UpsellPhase,
    [phases.PAYMENT]: IconPaymentForm
};

function mapStateToProps(state, ownProps) {
    let { download, editor } = state;

    return {
        download,
        editor
    };
}

export default connect(mapStateToProps, {
    fetchViewMoreIcons: actions.fetchViewMoreIcons,
    downloadRequest: actions.downloadRequest,
    downloadSelectLicense: actions.downloadSelectLicense,
    downloadCommitLicense: actions.downloadCommitLicense,
    downloadSelectAttribution: actions.downloadSelectAttribution,
    downloadCommitAttribution: actions.downloadCommitAttribution,
    downloadStart: actions.downloadStart,
    downloadSetFlowActive: actions.downloadSetFlowActive,
    downloadSelectFormat: actions.downloadSelectFormat,
    downloadResetFlow: actions.downloadResetFlow,
    downloadRepurchase: actions.downloadRepurchase,
    downloadJumpToLicense: actions.downloadJumpToLicense,
    downloadResetAttribution: actions.downloadResetAttribution,
    downloadDoUpsell: actions.downloadDoUpsell,
    downloadNoPremiumFeatures: actions.downloadNoPremiumFeatures,
    showModal: actions.showModal,
    dismissModal: actions.dismissModal,
    stripeGetSavedCard: actions.stripeGetSavedCard,
    editorTransform: actions.editorTransform
})(IconDownloadFlow);
